import React, { useState } from 'react';
import './WhatsAppButton.css';
import { useInitialFetch } from 'core/context/initialFetchContext';
import BaseModal from 'components/common/modal/BaseModal';
import { Modal, Button } from 'react-bootstrap';

import FormContact from 'components/artectum/common/contact-form-artectum';

const WhatsAppButton = () => {
    const { storeInformation } = useInitialFetch();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    
    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <>
        <button
            className="whatsapp-button"
            onClick={() => setIsFormOpen(true)}
            aria-label="Chat with us on WhatsApp"
        >
            <i className="fa-brands fa-whatsapp" style={{ "fontSize": "42px", "marginBottom": "4px" }}></i>
        </button>

        <BaseModal
            show={isFormOpen}
            title="Obten más información de este producto"
            handleClose={() => setIsFormOpen(false)}
            handleSave={() => setIsFormOpen(false)}
            size="lg"
        >
            <FormContact fromWsp={true} message={"Hola, quisiera más información acerca de sus servicios."} wspUrl={`https://wa.me/${storeInformation?.whatsapp}`} handleCloseParentModal={() => setIsFormOpen(false)} setModalIsOpen={setModalIsOpen} />
        </BaseModal>

        <Modal show={modalIsOpen} size="lg" onHide={closeModal}>
            <Modal.Header className="p-4 pb-0" closeButton>
                <Modal.Title>
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Formulario enviado con éxito
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <div id='product-pro-forma'>
                    <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default WhatsAppButton;
